import Type from '@/store/mutation-type';

export default {
  namespaced: 'map',
  state: {
    mapThemeId: 'dark', // 地图样式
    mapZoom: 13 // 地图层 级
  },
  mutations: {
    [Type.CHANGE_MAP_THEME](state, id) {
      state.mapThemeId = id;
    },
    [Type.MAP_ZOOM](state, zoom) {
      state.mapZoom = zoom;
    }
  }
};
